import {
  TextInput,
  MaskedInput,
  DatePicker,
  Select,
  Checkbox,
} from "components/inputs";

import type { SubPageType } from "types/FormTypes";
import type { ConstantTypes } from "types/DataTypes";
import { GENDERS } from "constants/FormConstants";

export const getClaimantForm = (constants: ConstantTypes): SubPageType[] => {
  return [
    {
      name: "Claimant Information",
      stepNumber: 1,
      path: "claimant-info",
      cards: [
        {
          cardNumber: 1,
          cardName: "Personal Information",
          fields: [
            {
              label: "First Name",
              component: TextInput,
              apiField: "first_name",
              componentProps: {
                placeholder: "First Name",
              },
            },
            {
              label: "Middle Name",
              component: TextInput,
              apiField: "middle_name",
              componentProps: {
                placeholder: "Middle Name",
              },
            },
            {
              label: "Last Name",
              component: TextInput,
              apiField: "last_name",
              componentProps: {
                placeholder: "Last Name",
              },
            },
            {
              label: "Gender",
              component: Select,
              apiField: "gender",
              componentProps: {
                placeholder: "Select Gender",
                options: GENDERS,
              },
            },
            {
              label: "SSN",
              component: MaskedInput,
              apiField: "ssn",
              componentProps: {
                mask: "ssn",
              },
            },
            {
              label: "Medicare ID",
              component: MaskedInput,
              apiField: "medicare_id",
              componentProps: {
                mask: "medicare",
              },
            },
            {
              label: "Birth Date",
              component: DatePicker,
              apiField: "birth_date",
              componentProps: {},
            },
            {
              label: "Medicare Eligible",
              component: Checkbox,
              apiField: "is_medicare_eligible",
              componentProps: {},
            },
          ],
        },
        {
          cardNumber: 2,
          cardName: "Address Information",
          fields: [
            {
              label: "Address",
              component: TextInput,
              apiField: "address",
              componentProps: {
                placeholder: "Street Address",
              },
            },
            {
              label: "City",
              component: TextInput,
              apiField: "city",
              componentProps: {
                placeholder: "City",
              },
            },
            {
              label: "State",
              component: Select,
              apiField: "state",
              componentProps: {
                placeholder: "Select State",
                options: constants?.STATES,
              },
            },
            {
              label: "ZIP Code",
              component: MaskedInput,
              apiField: "zip_code",
              componentProps: {
                mask: "zipcode-nine",
              },
            },
          ],
        },
      ],
    },
  ];
};
